import { ScannerHostIdentificationScanningIntensity } from '@rtkwlf/rendall';

import type { ScannerDetailsForm } from './types';

export const scannerInformationDefault: ScannerDetailsForm = {
  deviceType: 'virtual',
  model: 'scanner200',
  name: '',
  uuid: '',
  version: '',
  vulnScan: false,
  bruteScan: false,
  cgiScan: false,
  hostIden: false,
  pingOnly: false,
  hostIdentificationScanIntensity:
    ScannerHostIdentificationScanningIntensity.Medium,
  hostIdentificationScanPeriod: '5',
  maxConcurrentVulnerabilityScans: '0',
  lastScanCompletion: '',
  gateway: '',
  site: '1fa2b772-7769-4d92-bcfe-3dc7cd5c44db',
};
